import { render } from "./CollectionSortItem.vue?vue&type=template&id=3dfb1b1c"
import script from "./CollectionSortItem.vue?vue&type=script&lang=js"
export * from "./CollectionSortItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__